import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pill-listing-block',
  templateUrl: './pill-listing-block.component.html',
  styleUrls: ['./pill-listing-block.component.css']
})
export class PillListingBlockComponent implements OnInit {

  img: any;
  @Input() pillBlock_item: any = {};

  constructor() { }

  ngOnInit(): void {
    this.img = 'https://' + this.pillBlock_item.poster
  }

}
